import { createSelector } from 'reselect';
import { getCtaPreviewUrl } from '../utils/urls';
const getPreviewState = state => state.preview;
export const getPreviewDomain = createSelector(getPreviewState, previewState => previewState.previewDomain);
export const getPreviewUrl = createSelector([getPreviewDomain, (state, contentId) => contentId], (previewDomain, contentId) => getCtaPreviewUrl(previewDomain, contentId));
export const getPreviewPages = createSelector([getPreviewState], preview => preview.previewPages);
export const getPreviewPagesOptions = createSelector([getPreviewPages], previewPages => previewPages.map(previewPage => ({
  text: previewPage.name,
  value: previewPage.url
})));